module.exports = __webpack_public_path__ + "img/bg_page.cb4601ab.png";